export default {
  title: 'Practice Group Detail Report',
};
